import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_PERFORMANCE_CALCULATION,
  PAYOFF_COUPON_RESTRIKE,
  PAYOFF_COUPON_STRIKE,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { PERFORMANCE_CALCULATION_KEYS } from 'src/app/product-capture/model/consts/performance-calculation.const';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';

export const PERFORMANCE_LINKED_COUPON_SETTINGS = {
  id: ProductTypeEnum.PERFORMANCE_LINKED_COUPON,
  label: 'Performance-Linked Coupon',
  effects: [
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_CALLABILITY_CALLABILITY,
        PAYOFF_COUPON,
        PAYOFF_PARTICIPATION_FLOOR_STRIKE,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE, // Need to set PAYOFF_COUPON_TYPE to 'NONE' first, then set it to 'CALL' in order for the form to update correctly
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
      ],
      selectValues: ['NONE'],
      readOnly: false,
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_COUPON_RESTRIKE],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.CALL],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE],
      selectValues: ['FIXED'],
      hidden: false,
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['NONE'],
      hidden: false,
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_TYPE],
      hidden: false,
      readOnly: false,
      selectValues: ['CALL']
    },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
      ],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE],
      readOnly: true,
    },
    {
      formControlNames: [
        SUMMARY_PERFORMANCE_TYPE,
        SUMMARY_SETTLEMENT_TYPE,
        PAYOFF_COUPON_FREQUENCY,
        SUMMARY_FREQUENCY,
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [PERFORMANCE_TYPE_KEYS.SINGLE],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_COUPON_PERFORMANCE_CALCULATION],
      selectValues: [PERFORMANCE_CALCULATION_KEYS.FINAL_OVER_INITIAL],
    },
    {
      formControlNames: [PAYOFF_COUPON_RESTRIKE],
      selectValues: [true],
    },
    {
      formControlNames: [PAYOFF_COUPON_STRIKE],
      selectValues: [
        {
          value: '100%',
          minValue: null,
          maxValue: null,
          indicativeValue: null,
        },
      ],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: '100%',
          indicativeValue: null,
        },
      ],
    },
  ],
};
